<template>
  <div class="page-wrapper">
    <AppHeader title="Shifts" />
    <div class="container-fluid">
    <Void
      :open="isVoidOpen"
      @getVoidPermission="setVoidPermission($event)"
      @close="isVoidOpen = !isVoidOpen"
    />
    <div class="container-fluid left">
      <div class="row topnav" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <MainMenu />
          </div>
        </div> -->
        <div class="col-sm-12">
          <div v-show="showError" style="text-align: center">
            <label class="h3" style="color: maroon">
              {{ this.mainErrorMsg }}
            </label>
          </div>
        </div>
      </div>
      <div v-if="showAddPromotion" class="modal-overlay">
        <div class="modal-card">
          <div class="form-group mb-3">
            <label title="cashier" style="font-size: 1.2em; display: block; margin-bottom: 5px;">Cashier</label>
            <div class="wrap-input100 validate-input">
              <select
                class="form-control input-lg"
                id="cashier"
                v-model="cashier"
                name="cashier"
                style="font-size: 1.2em; border: 1px solid rgba(255,255,255,0.1); color: #fff;"
              >
                <option value="0" hidden>Select Cashier</option>
                <option v-for="user of allUsers" :key="user.id" :value="user.id">
                  {{ user.user_name }}
                </option>
              </select>
            </div>
          </div>
          <div style="text-align: right; margin-top: 20px;  padding-top: 20px;">
            <button
              class="btn btn-danger btn-lg"
              style="font-size: 1.2em; margin-right: 10px;"
              @click="cancelSavePromotion"
            >
              Cancel
            </button>
            <button
              class="btn btn-success btn-lg"
              v-if="shiftId === -1"
              style="font-size: 1.2em;"
              @click="createShift"
            >
              Save
            </button>
            <button
              class="btn btn-success btn-lg"
              v-if="shiftId !== -1"
              style="font-size: 1.2em;"
              @click="updateShift"
            >
              Update
            </button>
          </div>
        </div>
      </div>
      <div>

        <div class="touch-search-header">
          <div class="touch-search-area">
            <div class="input-group touch-search-group">
              <span class="input-group-addon">
                <i class="glyphicon glyphicon-search"></i>
              </span>
              <input
                type="text"
                v-model="searchShift"
                class="form-control input-lg"
                placeholder="Search shifts"
                @keyup.enter="applyShiftSearch()"
              />
              <span class="input-group-btn">
                <button class="btn btn-success btn-lg" @click="applyShiftSearch()">
                  Search
                </button>
              </span>
            </div>
          </div>
          <div class="touch-search-actions">
            <button
              class="btn btn-success btn-lg"
              v-if="hasPermission(70)"
              @click="handleAddShift"
            >
              New Shift
            </button>
          </div>
        </div>
        <br>
        <div
          class="row table-wrap"
          style="color: #fff; "
        >
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th style="font-size: 1.5em">Cashier Name</th>
                <th style="font-size: 1.5em">Open Datetime</th>
                <!-- <th style="font-size:1.5em">Close Datetime</th> -->
                <!-- <th style="font-size: 1.5em"></th>
                <th style="font-size: 1.5em"></th>
                <th style="font-size: 1.5em"></th>
                <th style="font-size: 1.5em"></th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="shift in filteredShifts" :key="shift.id">
                <td style="font-size: 1.5em">{{ shift.cashier_name }}</td>
                <td style="font-size: 1.5em">{{ shift.open_datetime }}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import AppHeader from "@/components/AppHeader";
import MainMenu from "@/components/MainMenu";
import Void from "@/components/Void";
export default {
  computed: {
    filteredShifts() {
      let list = this.allShifts || [];
      const search = (this.searchShift || "").toLowerCase();

      if (search) {
        list = list.filter((s) => {
          const cashier = (s.cashier_name || "").toLowerCase();
          const open = (s.open_datetime || "").toLowerCase();
          const id = (s.id || "").toString().toLowerCase();
          return cashier.includes(search) || open.includes(search) || id.includes(search);
        });
      }

      return list;
    },
  },
  mixins: [commonServices],
  mounted() {
    this.getAllShifts(true);
    this.getAllUsers();
    if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
    } else {
      this.$router.push({ name: "login" });
    }
    this.language = "ar";
    this.handleLanguage();
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { MainMenu, Void, AppHeader },
  data: function () {
    return {
      showAddPromotion: false,
      allShifts: [],
      searchShift: "",
      shiftJson: {},
      allUsers: [],
      shiftId: -1,
      cashier: 0,
      authorizedToChangePrice: "N",
      isVoidOpen: false,
      open_datetime: new Date(),
      close_datetime: "",
      showError: false,
      mainErrorMsg: "",
      logoUrl: "",
      jsonData: {},
      language: "en",
      languageName: "",
      isShiftClosed: false,
      toggle: true,
      showFilterUser: false,
    };
  },
  methods: {
    applyShiftSearch() {
      this.searchShift = (this.searchShift || "").trim();
    },
    getAllUsers: async function () {
      this.shiftJson.appId = localStorage.appId;
      try {
        let dataURL = this.apiURL + "Users/getAllUsers";
        let response = await axios.post(dataURL, this.shiftJson);
        if (response.data.status === "success") {
          this.allUsers = response.data.results;
        }
      } catch (error) {
        console.log(error);
      }
      return this.allUsers;
    },
    editShift(shift) {
      this.cashier = shift.cashier;
      this.open_datetime = shift.open_datetime;
      this.close_datetime = shift.close_datetime;
      this.shiftId = shift.id;
      this.showAddPromotion = true;
    },
    deleteShift: function (shift) {
      this.isVoidOpen = true;
      this.shiftId = shift.id;
    },
    createShift: async function () {
      if (this.cashier == "") {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.shiftJson.appId = localStorage.appId;
      this.shiftJson.cashier = this.cashier;
      this.shiftJson.open_datetime = null;
      this.shiftJson.close_datetime = null;
      try {
        let dataURL = this.apiURL + "Shifts/createShift";
        let response = await axios.post(dataURL, this.shiftJson);
        if (response.data.status === "success") {
          this.showSuccess("Shift Added Successfully!");
          this.getAllShifts();
          this.cancelSavePromotion();
        } else {
          this.showAlert("you have a shift open");
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancelSavePromotion() {
      this.toggle = true;
      this.showAddPromotion = false;
      this.showPermissions = false;
      this.isShiftClosed = false;
      this.showFilterUser = false;
      this.cashier = 0;
      this.showDuplicatePromotion = false;
    },
    async setVoidPermission(authorizedToChangePrice) {
      if (authorizedToChangePrice === "Y") {
        this.shiftJson.appId = localStorage.appId;
        this.shiftJson.id = this.shiftId;

        try {
          let dataURL = this.apiURL + "Shifts/deleteShift";
          let response = await axios.post(dataURL, this.shiftJson);
          if (response.data.status === "success") {
            this.showSuccess("Shift Deleted Successfully!");
            this.getAllShifts();
            this.cancelSavePromotion();
          } else {
            this.showAlert("Error Happened Please Check Entered Data!");
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        // Error message mo permission
      }
      this.authorizedToChangePrice = "N";
    },
    updateShift: async function () {
      if (this.open_datetime == "" || this.cashier == "") {
        this.showAlert("Please Fill All fields!");
        return;
      }
      this.shiftJson.appId = localStorage.appId;
      this.shiftJson.id = this.shiftId;
      this.shiftJson.cashier = this.cashier;
      this.shiftJson.open_datetime = this.open_datetime;
      this.shiftJson.close_datetime = this.close_datetime
        ? this.close_datetime
        : null;

      try {
        let dataURL = this.apiURL + "Shifts/updateShift";
        let response = await axios.post(dataURL, this.shiftJson);
        if (response.data.status === "success") {
          this.showSuccess("Shift Updated Successfully!");
          this.getAllShifts();
          this.cancelSavePromotion();
        } else {
          this.showAlert("Error Happened Please Check Entered Data!");
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleAddShift: async function () {
      this.showAddPromotion = true;
      this.shiftId = -1;
      this.cashier = "";
      this.open_datetime = "";
      this.ura = "";
      this.close_datetime = "";
      this.showError = false;
      this.mainErrorMsg = "";
      this.showAddCustomer = true;
    },
    getAllShifts: async function (init) {
      if (init) {
        this.shiftJson = {
          appId: localStorage.appId,
          init: true,
        };
      } else {
        this.shiftJson = {
          appId: localStorage.appId,
          isShiftClosed: this.isShiftClosed,
        };
        if (this.showFilterUser) {
          this.shiftJson.cashier = this.cashier;
        }
      }

      try {
        let dataURL = this.apiURL + "Shifts/getAllShifts";
        let response = await axios.post(dataURL, this.shiftJson);
        if (response.data.status === "success") {
          this.allShifts = response.data.results;
        }
      } catch (error) {
        console.log(error);
      }
      return this.allShifts;
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

/* شكل الـ select نفسه */
#cashier {
  background-color: #353947;   /* خلفية بيضاء */
  color: #ffffff;              /* لون النص أبيض */
}

/* شكل الخيارات داخل القائمة */
#cashier option {
  background-color: #ffffff;   /* خلفية الخيارات بيضاء */
  color: #000000;              /* لون النص داخل القائمة أسود */
}
.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}

.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}

.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}

.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}

.check-label {
  color: #fff;
  font-size: 1.5rem;
  margin-left: 1rem;
  margin: 1rem 0;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-card {
  width: 100%;
  max-width: 600px;
  background-color: var(--form-color);
  color: var(--theme-text-main);
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  padding: 30px;
}
</style>
